import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { key } from './config';

const List = lazy(() => import('./index'));
const Update = lazy(() => import('./update'));

export default function RegionalEfficiencyRoutes() {
  return (
    <Route path={key}>
      <Route index element={<List />} />
      <Route path=":id/update" element={<Update />} />
    </Route>
  );
}
